import React, { useEffect, useState } from "react";

const API_URL = "https://admin.augschoell.com/wp-json/wp/v2/bilder";

// Cache für bereits geladene Bilder
const imageCache = new Map();

const Image = ({ slug, alt = "", ...props }) => {
    const [src, setSrc] = useState("");

    useEffect(() => {
        if (!slug) return;

        let active = true;

        const loadImage = async () => {
            try {
                let promise = imageCache.get(slug);

                if (!promise) {
                    promise = fetch(
                        `${API_URL}?slug=${encodeURIComponent(slug)} `
                    ).then(async (response) => {
                        if (!response.ok) {
                            throw new Error("Fehler beim Laden des Bildes");
                        }

                        const data = await response.json();

                        if (!data.length) {
                            throw new Error(
                                `Kein Bild mit Slug "${slug}" gefunden`
                            );
                        }

                        // URL des Bildes aus der API
                        return data[0].acf.bild;
                    });

                    imageCache.set(slug, promise);
                }

                const url = await promise;

                if (active) setSrc(url);
            } catch (error) {
                imageCache.delete(slug);
                console.error(error);
            }
        };

        loadImage();

        return () => {
            active = false;
        };
    }, [slug]);

    if (!src) return null;

    return <img src={src} alt={alt} {...props} />;
};

export default Image;